const MAX_BYTES = 50 * 1024 * 1024;

export const validateSalesDocumentFile = (
  file,
  { extensions, formatError, mimeTypes, sizeError }
) => {
  const extension = file?.name?.toLowerCase().split('.').pop();
  if (!mimeTypes.includes(file?.type) || !extensions.includes(extension)) {
    return formatError;
  }
  if (!file.size || file.size > MAX_BYTES) return sizeError;
  return '';
};

export const uploadSalesDocumentFiles = (files, uploadFile) =>
  Array.from(files || []).reduce(
    (queue, file) =>
      queue.then(results =>
        uploadFile(file).then(result => [...results, result])
      ),
    Promise.resolve([])
  );
